import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import Modal from 'shared/components/Modal';
import FuturePortalLayout from '../../layouts/FuturePortalLayout';
import CalendarActions from 'agent_portal/actions/CalendarActions';
import ProviderAndLocationSelect from './ProviderAndLocationSelect';
import SmallCalendar from './SmallCalendar';
import BigCalendar from './BigCalendar';
import NewSlotModal from './modals/NewSlotModal';
import ViewEditSlotModal from './modals/ViewEditSlotModal';
import classes from './CalendarNewPage.module.scss';
import LoadingContent from 'shared/components/LoadingContent';

class SchedulerPage extends Component {
  componentDidMount() {
    CalendarActions.fetchScheduleBaseData().then(CalendarActions.fetchAppointmentSlots);
  }

  render() {
    const { appointmentSlots, newSlotModalOpen, viewSlotModalOpen, pageTitle } = this.props;
    const slotEvents = appointmentSlots.map(slot => ({
      title: slot.text || 'Slot',
      start: moment(slot.startDate, 'YYYY-MM-DDTHH:mm:ss').toDate(),
      end: moment(slot.endDate, 'YYYY-MM-DDTHH:mm:ss').toDate(),
      id: slot.id,
      locationId: slot.locationId,
      taken: slot.taken,
    }));

    return (
      <FuturePortalLayout title={pageTitle}>
        {this.props.date ? (
          <div className={classes.container}>
            <div className={classes.side_panel}>
              <SmallCalendar date={this.props.date} />
              <ProviderAndLocationSelect />
            </div>
            <div className={classes.main_panel}>
              <BigCalendar events={slotEvents} />
            </div>
            <Modal show={newSlotModalOpen} onHide={CalendarActions.hideModal}>
              <NewSlotModal />
            </Modal>
            <Modal show={viewSlotModalOpen} onHide={CalendarActions.hideModal}>
              <ViewEditSlotModal />
            </Modal>
          </div>
        ) : (
          <LoadingContent />
        )}
      </FuturePortalLayout>
    );
  }
}

function mapStateToProps(state) {
  const { providerEmployments, selectedProviderEmploymentId } = state.calendar;
  const currentProvider = providerEmployments.find(
    pe => pe.providerEmploymentId === selectedProviderEmploymentId
  );
  const pageTitle = currentProvider ? `Calendar › ${currentProvider.providerName}` : 'Calendar';
  return {
    currentAgent: state.currentAgent,
    newSlotModalOpen: state.calendar.newSlotModalOpen,
    viewSlotModalOpen: state.calendar.viewSlotModalOpen,
    appointmentSlots: state.calendar.appointmentSlots,
    date: state.calendar.date,
    pageTitle,
  };
}

export default connect(mapStateToProps)(SchedulerPage);
